import { useState } from "react";
import styled from "styled-components";
import "../Styles/component.css";

const PeriodOption = ({ optionChange }) => {
  const [selectedOption, setSelectedOption] = useState("일간");

  const handleOptionChange = (value) => {
    setSelectedOption(value);
    if (value === "일간") optionChange("day");
    else if (value === "주간") optionChange("week");
    else if (value === "월간") optionChange("month");
    else optionChange("");
  };
  return (
    <OptionBox>
      {["일간", "주간", "월간", "전체"].map((option) => (
        <OptionBtn
          key={option}
          $isSelected={selectedOption === option}
          onClick={() => handleOptionChange(option)}
        >
          {option}
        </OptionBtn>
      ))}
    </OptionBox>
  );
};

const OptionBox = styled.div`
  width: 204px;
  height: 44px;
  border-radius: 12px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const OptionBtn = styled.div`
  width: 46px;
  height: 36px;
  border-radius: 8px;
  background-color: ${({ $isSelected }) =>
    $isSelected ? "#ffffff" : "#f5f5f5"};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 2px;
  margin-right: 2px;
  font-family: "notoSans-medium";
  font-size: 14px;
  color: ${({ $isSelected }) => ($isSelected ? "#222222" : "#757575")};
  cursor: pointer;
`;

export default PeriodOption;
